import { render } from "./TheaterPlayer.vue?vue&type=template&id=72d8bbe1&scoped=true&ts=true"
import script from "./TheaterPlayer.vue?vue&type=script&lang=ts"
export * from "./TheaterPlayer.vue?vue&type=script&lang=ts"

import "./TheaterPlayer.vue?vue&type=style&index=0&id=72d8bbe1&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d8bbe1"]])

export default __exports__